import Footer from "../components/Footer";
import Navbar from "../components/Navbar";
import CitySearch from "../components/CitySearch";

function CityFooterPage() {
  return (
    <div className="font-inter flex flex-col min-h-screen">
      <Navbar />
      <div className="container mx-auto px-4 sm:px-6 md:px-6 lg:px-8 xl:px-16 2xl:px-24">
        <CitySearch />
      </div>
      <Footer />
    </div>
  );
}

export default CityFooterPage;